import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallbackPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = new URLSearchParams(window.location.search).get('code');

      if (code) {
        // Exchange code for session manually
        const { data, error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);
        
        if (exchangeError) {
          setError(exchangeError.message);
          setTimeout(() => {
            navigate('/login', { replace: true });
          }, 2000);
        } else if (data && data.session) {
          navigate('/search', { replace: true });
        }
      } else {
        // No code, maybe user returned after successful auth but didn't have a code in URL (e.g. Implicit grant)
        const { data, error: sessionError } = await supabase.auth.getSession();
        
        if (data && data.session) {
          navigate('/search', { replace: true });
        } else {
          // If there is no code and no active session, redirect back to login
          navigate('/login', { replace: true });
        }
      }
    };

    handleCallback();

    // Safety timeout: if still loading after 10 seconds, redirect to login
    const timeoutId = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 10000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p className="text-gray-400 mt-4">Completing sign in...</p>
        <p className="text-gray-500 text-sm mt-2">Please wait while we verify your account</p>
        {error && <p className="text-red-400 text-sm mt-4">{error}</p>}
      </div>
    </div>
  );
};

export default AuthCallbackPage;
